import "./assign-selected-plan-block.scss";
import FontHeading4 from "../../../../components/fonts/font-heading4/font-heading4";
import { Button } from "../../../../components/inputs/button/button";
import { FONT_VARIANT } from "../../../../components/fonts/font-props";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import AssignShopsToPlanStore from "../../stores/assign-shops-to-plan-store";

interface AssignSelectedPlanBlockProps {
    store?: AssignShopsToPlanStore;
    onAssignShopsClick: (value: boolean) => void;
}

const AssignSelectedPlanBlock: React.FC<AssignSelectedPlanBlockProps> = ({ store, onAssignShopsClick }) => {
    return (
        <div className="assign-selected-plan-block">
            <FontHeading4 variant={FONT_VARIANT.BOLD}>{store?.plan ? '1 item selected' : 'Select an item'}</FontHeading4>
            <div className="actions">
                <Button
                    onClick={() => onAssignShopsClick(true)}
                    disabled={!store?.plan || store.plan.deprecated}
                    variant={BUTTON_VARIANTS.Secondary}
                    text="Assign stores"
                />
                {/* <Button
                    disabled={!store?.plan || store?.plan.deprecated}
                    variant={BUTTON_VARIANTS.Secondary}
                    text="Assign trial days"
                /> */}
            </div>
        </div>
    );
};

export default AssignSelectedPlanBlock;
